import { COLORS } from '@cocolocala/ui-components';
import { createFontStyle, MOBILE_FONT_STYLES } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import { useRouter } from 'next/router';
import qs from 'query-string';
import React, { CSSProperties, FC } from 'react';
import SignUpOrSignInTabs from '~/feature/order/sign/components/mobile/SignUpOrSignInTabs';
import BusyOverlay from '~/shared/components/shared/BusyOverlay';
import SignForm from '~/shared/components/shared/SignForm';
import { SIGN_TYPE, SIGN_TYPES } from '~/shared/components/Sign/types';
type Props = {
  onSubmitSignUp: (data) => void; // 無料会員登録するボタンが押された
  onSubmitSignIn: (data) => void; // ログインするボタンが押された
  onClickTab: (currentTab: SIGN_TYPE) => void; // タブがタップされた
  isSubmitting: boolean;
  signType: SIGN_TYPE;
  style?: CSSProperties;
};
const SignContainer: FC<Props> = ({
  onSubmitSignIn,
  onSubmitSignUp,
  onClickTab,
  isSubmitting,
  signType,
  style
}) => {
  const router = useRouter();
  return <Container style={style}>
      <BusyOverlay isBusy={isSubmitting} messageTitle={'しばらくそのままお待ちください'} messageBody={'元の画面に戻ると内容が無効になることがあります。'}>
        <PageTitle>
          {signType === SIGN_TYPES.SIGN_UP ? '無料会員登録' : 'ログイン'}
        </PageTitle>
        <FloatingWrapper>
          <SignUpOrSignInTabs currentTabType={signType} onClickTab={onClickTab} />
          <SignFormWrapper>
            {signType === SIGN_TYPES.SIGN_UP ? <SignForm onSubmit={onSubmitSignUp} formType={'sign-up'} submitButtonLabel="無料会員登録する" queryParameters={qs.stringify(router.query)} /> : <SignForm onSubmit={onSubmitSignIn} formType={'sign-in'} submitButtonLabel="ログインする" queryParameters={qs.stringify(router.query)} />}
          </SignFormWrapper>
        </FloatingWrapper>
        {signType === SIGN_TYPES.SIGN_UP && <EmailDescription>
            サポートチームより予約の状況・変更・キャンセルのご連絡をいたします。
            <span>「cocolocala.jp」</span>
            からのメールを受信できるようドメイン指定・迷惑メール等の設定をしてください。
          </EmailDescription>}
      </BusyOverlay>
    </Container>;
};
export default SignContainer;
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "cfl8x2y"
});
const PageTitle = /*#__PURE__*/styled("div")({
  name: "PageTitle",
  class: "pqnvwia"
});
const FloatingWrapper = /*#__PURE__*/styled("div")({
  name: "FloatingWrapper",
  class: "f1t7b6f6"
});
const SignFormWrapper = /*#__PURE__*/styled("div")({
  name: "SignFormWrapper",
  class: "snx2u9l"
});
const EmailDescription = /*#__PURE__*/styled("p")({
  name: "EmailDescription",
  class: "e15vjrxd"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");